export var masterFirebaseConfig = {
  apiKey: "AIzaSyATHYYfBz69t2rP06_Q9iRxo_I4zuaR3v0",
  authDomain: "drum-mach.firebaseapp.com",
  databaseURL: "https://drum-mach.firebaseio.com",
  projectId: "drum-mach",
  storageBucket: "drum-mach.appspot.com",
  messagingSenderId: "999113933928"
}



// WEBPACK FOOTER //
// /Users/BREA/Desktop/drum-machine/src/app/api-keys.ts